export class StatusChangeType {
    id?: number;
    name: String;
}
